import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Headphones, Zap, GitBranch, FileCheck, ArrowRight } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

const ICONS = [Headphones, Zap, GitBranch, FileCheck];

export default function SupportSection() {
  const { lang } = useLang();
  const t = HOME_I18N[lang].support;

  return (
    <section className="section bg-[#F8FAFC]" data-testid="support-section">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="eyebrow">{t.eyebrow}</span>
          <h2 className="mt-3 h2-section">
            {t.title1}<br />
            <span className="text-[#2563EB]">{t.titleAccent}</span>
          </h2>
          <p className="mt-5 body-lg max-w-2xl">{t.desc}</p>
        </div>

        <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {t.cards.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={c.t}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.4, delay: i * 0.06 }}
                className="rounded-2xl border border-slate-200 bg-white p-7 transition hover:shadow-lg hover:-translate-y-1"
                data-testid={`support-card-${i}`}
              >
                <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-[#2563EB]/8 text-[#2563EB] border border-[#2563EB]/15">
                  <Icon className="h-5 w-5" strokeWidth={1.8} />
                </span>
                <h3 className="mt-5 font-heading text-base font-semibold text-[#07111F]">{c.t}</h3>
                <p className="mt-2 text-sm leading-relaxed text-[#334155]">{c.d}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-12">
          <Link to="/proje-talep" data-testid="support-cta" className="inline-flex items-center gap-2 text-sm font-semibold text-[#2563EB] hover:gap-3 transition-all">
            {t.cta} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </section>
  );
}
